<app-rendered [childview]="item.childview || childview" [info]="info" *ngFor="let it of item.content" [item]="it" [arr]="item.content" [data]="data" [paramprefix]="item.paramprefix"></app-rendered>
